import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  companyIds: Array<number>
  onError?: (error: unknown) => void
  enabled?: boolean
}

export default function useLayouts({onError, enabled = true, companyIds}: Props) {
  const query = useQuery({
    enabled,
    queryKey: [QueryKeyEnum.LAYOUTS, companyIds],
    queryFn: async () =>
      (
        await api.layout.getMany({
          includes: ['cameras'],
          orderBy: {layoutType: 'DESC'},
          filter: {companyIds},
        })
      ).data.data.entities,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
